import {
	syncRequiredStates,
	wheelAmpersexStates,
	wheelOnlyPrepStates,
	wheelOnlyStates,
} from '@data/US_States';
import usStates from '@data/US_States';

export const syncRequired = 'sync_required';
export const asyncRequired = 'async_required';
export const visitOptional = 'visit_optional';
export type VisitRequirements = 'sync_required' | 'async_required' | 'visit_optional';

export const visitRequirements = (state: string): VisitRequirements | undefined => {
	if (wheelOnlyPrepStates.includes(state)) {
		return asyncRequired;
	}
	if (syncRequiredStates.includes(state)) {
		return syncRequired;
	}
	if (wheelOnlyStates.includes(state)) {
		return asyncRequired;
	}
	if (wheelAmpersexStates.includes(state)) {
		return visitOptional;
	}
	return undefined;
};

export const getStateName = (stateAbbr?: string) => {
	return usStates.find(({ value }) => value === stateAbbr)?.label;
};
